import React from 'react';

import PropTypes from 'prop-types';

import BaseHeroHeader from 'wanderu-component-hero-header';

function HeroHeader(props) {
    const {
        className,
        title,
        widgetProps = {},
    } = props;

    return (
        <BaseHeroHeader
            className={className}
            showAppDownloadCTA={false}
            title={title}
            widgetProps={widgetProps}
        />

    );
}

HeroHeader.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    widgetProps: PropTypes.object,
};

export default HeroHeader;
